export default __webpack_public_path__ + "static/media/MT2_activations_XZ.b08700de.png";